import { Component } from 'react';

import { loadNotifications } from 'common/actions/notifications';
import cloneElementWithProps from 'common/core/cloneElementWithProps';
import connect from 'common/core/connect';

type OwnProps = {
  children: React.ReactNode;
};
type ConnectProps = {
  loadNotifications: () => void;
};

type Props = OwnProps & ConnectProps;

class CompanyNotificationsContainer extends Component<Props> {
  componentDidMount() {
    this.props.loadNotifications();
  }

  render() {
    return cloneElementWithProps(this.props.children, this.props);
  }
}

export default connect(null, {
  loadNotifications,
})(CompanyNotificationsContainer) as unknown as React.ComponentClass<OwnProps>;
